$( function() { 
    ///////////////////////////////
    ///////////// GTM /////////////
    ///////////////////////////////

    $("a").click(function (e) {
        if ($(this).data('cta') !== undefined) {
            dataLayer.push({
                'event' : 'mjml',
                'eventValue' : 'mjmlHome-CtaClicked',
                'button': $(this).data('cta')
            });
        }
    });

    $("button").click(function (e) {
        if ($(this).data('cta') !== undefined) {
            dataLayer.push({
                'event' : 'mjml',
                'eventValue' : 'mjmlHome-CtaClicked',
                'button': $(this).data('cta')
            });
        }
    });
})
